export default __webpack_public_path__ + "793c999373601f6cda167e634009aa75.png";